var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bi-control-panel-tab"},[_c('BIApprovalFilter'),_c('BIApprovalTable',{attrs:{"can-edit":_vm.canEdit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }